import { useEffect } from "react";
import { Sidebar } from "@/components/layout/Sidebar";
import { Topbar } from "@/components/layout/Topbar";
import { useAuth } from "@/context/AuthContext";

export function AppShell({ children }) {
  const { user } = useAuth();
  // Reset the browser tab title to the platform name once inside the app —
  // the login page sets an institution-specific title that would otherwise
  // linger (e.g. "St. Peter's School" from an older session).
  useEffect(() => {
    document.title = "Kampus 365 — School Operating System";
  }, []);
  return (
    <div className="min-h-screen bg-[hsl(var(--background))] flex p-3 gap-3" data-testid="app-shell">
      <Sidebar user={user} />
      <div className="flex-1 flex flex-col min-w-0 gap-3">
        <Topbar />
        <main className="flex-1 min-w-0" data-testid="app-main">
          {children}
        </main>
      </div>
    </div>
  );
}
